export default __webpack_public_path__ + "static/media/i-stack-1.3b3c50d8.svg";